var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmallBusiness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Workflow-Teamwork-User-High-Five--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Workflow Teamwork User High Five Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.72 9.95a2.45 2.45 0 1 0 4.9 0 2.45 2.45 0 1 0 -4.9 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.38 9.95a2.45 2.45 0 1 0 4.9 0 2.45 2.45 0 1 0 -4.9 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.5a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.37 2.88a1 1 0 0 0 -1.41 0l-1.42 1.41a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.41 -1.42a1 1 0 0 0 0 -1.41Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 6A1 1 0 0 1 7 5.71L5.63 4.29A1 1 0 0 1 7 2.88l1.46 1.41a1 1 0 0 1 0 1.42 1 1 0 0 1 -0.71 0.29Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 23.5v-6.73a6.35 6.35 0 0 1 -5.4 -4.32l-0.84 -2.53A1.46 1.46 0 0 1 11.29 8a1.51 1.51 0 0 1 1.64 1.06l0.82 2.45A3.41 3.41 0 0 0 17 13.86h4.3a2 2 0 0 1 2 2v7.64Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.54 12.92 0 -0.13A3.41 3.41 0 0 1 7 13.86H2.71a2 2 0 0 0 -2 2v7.64H7.6v-6.73a6.37 6.37 0 0 0 3.33 -1.33 7.83 7.83 0 0 1 -1.39 -2.52Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmallBusiness);
export default ForwardRef;